class Search {
    constructor (theme, elem) {
        this.elem = elem
    }

    onInit () {
        this._clearButton = this.elem.querySelector('[data-search-input-clear]')
        this._input = this.elem.querySelector('[name="q"]')
        this._fakeInput = this.elem.querySelector('[data-search-input]')

        if (this._input.value.length > 0) {
            this._showClearButton(null, true)
        }

        this.elem.addEventListener('submit', (e) => {
            this._input.value = `${this._fakeInput.value}*`
            return true
        })

        this._fakeInput.addEventListener('keyup', (e) => {
            this._showClearButton(e)
        })

        this._clearButton.addEventListener('click', () => {
            this._clearInput()
        })
    }

    _clearInput () {
        this._input.value = ''
        this._fakeInput.value = ''
        this.elem.classList.remove('search-input-clear--visible')
    }

    _showClearButton (e, defaultState = false) {
        if (e === null && defaultState === true) {
            this.elem.classList.add('search-input-clear--visible')
        } else if (e.target.value.length > 0) {
            this.elem.classList.add('search-input-clear--visible')
            return true
        } else {
            this.elem.classList.remove('search-input-clear--visible')
        }
    }
}

export default Search



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Search.js